import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchRequesterLink } from '@app/store/requesterLink/actions';

function FetchRequesterLink({ documentId, exitPath }: { documentId: string; exitPath?: string }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (documentId) {
      dispatch(
        fetchRequesterLink({
          documentId,
          exitPath,
        })
      );
    }
  }, [dispatch, documentId, exitPath]);

  return null;
}

export default FetchRequesterLink;
